import dayjs, { Dayjs } from "utils/dayjs"

import AmountWithCurrency, { IAmountWithCurrencyDto } from "./AmountWithCurrency"

export interface IGetImputedInterestCalculationDto {
    periodFrom: string
    netPresentValue: IAmountWithCurrencyDto
    imputedInterest: IAmountWithCurrencyDto
    netAverageValue: IAmountWithCurrencyDto
    imputedInterestAverage: IAmountWithCurrencyDto
    imputedInterestInvoiced?: IAmountWithCurrencyDto
    splitOccured: boolean
}

export class ImputedInterestCalculation {
    periodFrom: Dayjs
    netPresentValue: AmountWithCurrency
    imputedInterest: AmountWithCurrency
    netAverageValue: AmountWithCurrency
    imputedInterestAverage: AmountWithCurrency
    imputedInterestInvoiced?: AmountWithCurrency
    splitOccured: boolean

    constructor(dto: IGetImputedInterestCalculationDto) {
        this.periodFrom = dayjs(dto.periodFrom, "YYYY-MM-DD") // take only date ignoring the time
        this.netPresentValue = new AmountWithCurrency(dto.netPresentValue)
        this.imputedInterest = new AmountWithCurrency(dto.imputedInterest)
        this.netAverageValue = new AmountWithCurrency(dto.netAverageValue)
        this.imputedInterestAverage = new AmountWithCurrency(dto.imputedInterestAverage)
        this.imputedInterestInvoiced = dto.imputedInterestInvoiced ? new AmountWithCurrency(dto.imputedInterestInvoiced) : undefined
        this.splitOccured = dto.splitOccured
    }
}
